module.exports = __webpack_public_path__ + "static/media/sentiment_very_dissatisfied_v2.9f94da42.svg";